module.exports = __webpack_public_path__ + "93349923b5274a36ac93cb3168d09123.svg";